var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M503.172,423.724H8.828c-4.875,0-8.828-3.952-8.828-8.828V97.103c0-4.875,3.952-8.828,8.828-8.828   h494.345c4.875,0,8.828,3.952,8.828,8.828v317.793C512,419.772,508.048,423.724,503.172,423.724z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.76,
    y: 0,
    style: {
      fill: "#F5F5F5"
    },
    width: 282.48,
    height: 512
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#FF4B55"
    },
    width: 114.76,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.24,
    y: 0,
    style: {
      fill: "#FF4B55"
    },
    width: 114.76,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M309.57,294.76l52.383-29.933l-12.02-6.01c-3.371-1.686-5.301-5.326-4.802-9.063l3.911-29.322   l-22.177,6.452c-4.899,1.425-9.983-1.587-11.085-6.569l-2.124-9.6l-20.823,24.37c-2.886,3.378-8.386,0.797-7.633-3.581   l8.892-51.708l-13.615,3.724c-3.977,1.088-8.176-0.722-10.117-4.359l-14.337-26.871v-0.039l-0.01,0.02l-0.011-0.02v0.039   l-14.337,26.871c-1.941,3.637-6.14,5.447-10.117,4.359l-13.615-3.724l8.892,51.708c0.753,4.379-4.747,6.959-7.633,3.581   l-20.823-24.37l-2.124,9.6c-1.102,4.982-6.186,7.994-11.085,6.569l-22.178-6.452l3.911,29.322c0.498,3.736-1.431,7.377-4.802,9.063   l-12.02,6.01l52.383,29.933c5.426,3.1,7.803,9.677,5.615,15.53l-4.478,11.977l44.885-3.832c2.484-0.212,4.598,1.787,4.525,4.279   l-1.413,48.043h8.828l-1.413-48.045c-0.073-2.492,2.041-4.492,4.525-4.279l44.906,3.834l-4.478-11.977   C301.766,304.438,304.144,297.861,309.57,294.76z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.c38c1e1000df8659feabb46c605d6810.svg";
export { ForwardRef as ReactComponent };